const CopyIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.0833 8.01667V10.8167C10.0833 13.15 9.15 14.0833 6.81667 14.0833H4.01667C1.68333 14.0833 0.75 13.15 0.75 10.8167V8.01667C0.75 5.68333 1.68333 4.75 4.01667 4.75H6.81667C9.15 4.75 10.0833 5.68333 10.0833 8.01667Z"
        stroke={"#2E3860"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M14.0833 4.01667V6.81667C14.0833 9.15 13.15 10.0833 10.8167 10.0833H10.0833V8.01667C10.0833 5.68333 9.15 4.75 6.81667 4.75H4.75V4.01667C4.75 1.68333 5.68333 0.75 8.01667 0.75H10.8167C13.15 0.75 14.0833 1.68333 14.0833 4.01667Z"
        stroke={"#2E3860"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
};

export default CopyIcon;
